import React from 'react';
import './AdminInsightCard.css';

// The standard "what/why/action" pattern for every admin insight
// (docs/UI_UX_ARCHITECTURE.md Admin Phase 5 §3). Never a bare number —
// `what` is always the headline metric, `why` the one-line real cause
// already computed by an existing service (never invented here), `action`
// an optional CTA. Reuses the axh- design system's card/token language.
const AdminInsightCard = ({ what, why, actionLabel, onAction, tone = 'default' }) => (
  <div className={`aic-card aic-card--${tone}`}>
    <div className="aic-what">{what}</div>
    {why && <div className="aic-why"><span className="aic-why-label">Why:</span> {why}</div>}
    {actionLabel && (
      <button type="button" className="aic-action" onClick={onAction}>{actionLabel}</button>
    )}
  </div>
);

export default AdminInsightCard;
